import { atom } from "jotai";
import { edgesAtom } from "./edgesAtom";

export const areAllEdgesDeselectedAtom = atom((get) => {
  const edges = get(edgesAtom);
  return edges.every((edge) => !edge.selected);
});

areAllEdgesDeselectedAtom.debugLabel = "areAllEdgesDeselectedAtom";
